import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// types
import { ToolDescription } from '../utils/types';

export interface RouteChangeHandlerProps {
  tools: ToolDescription[];
  baseTitle: string;
}

export function RouteChangeHandler({ tools, baseTitle }: RouteChangeHandlerProps) {
  const location = useLocation();
  // set the currently selected tool by reading the URL.

  useEffect(() => {
    //
    // Runs on every navigation
    let url: string = location.pathname;

    // extract the part including the last '/'/
    if (url.lastIndexOf('/') > -1) {
      //
      if (url.length === url.lastIndexOf('/') + 1) {
        url = '';
      } else {
        url = url.slice(-(url.length - url.lastIndexOf('/')));
      }

      for (let i: number = 0; i < tools.length; i++) {
        if (tools[i].link === url) {
          document.title = baseTitle + ' - ' + tools[i].text;
        }
        for (let j: number = 0; j < tools[i].subItems.length; j++) {
          if (tools[i].subItems[j].link === url) {
            document.title = baseTitle + ' - ' + tools[i].subItems[j].text;
          }
        }
      }
    }
    //
  }, [location]);

  return null; // This component renders nothing
}
